module.exports = __webpack_public_path__ + "img/ps4.51c809f5.svg";